import { render } from "./OfferItem.vue?vue&type=template&id=3fecb5f2&scoped=true"
import script from "./OfferItem.vue?vue&type=script&lang=js"
export * from "./OfferItem.vue?vue&type=script&lang=js"

import "./OfferItem.vue?vue&type=style&index=0&id=3fecb5f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fecb5f2"]])

export default __exports__